import { render, staticRenderFns } from "./EventsDisplay.vue?vue&type=template&id=2bbee2c2&"
import script from "./EventsDisplay.vue?vue&type=script&lang=js&"
export * from "./EventsDisplay.vue?vue&type=script&lang=js&"
import style0 from "./EventsDisplay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports